import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-media_export",
  "use": "icon-media_export-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-media_export\"><defs><style>#icon-media_export .a{fill:none;}#icon-media_export .b{fill:;}</style></defs><path class=\"a\" d=\"M0,0H16V16H0Z\" /><path class=\"b\" d=\"M15.331,9.749A4,4,0,0,0,9.534,15H2.667A.667.667,0,0,1,2,14.33V3.666A.667.667,0,0,1,2.667,3H7.608L8.941,4.333h5.723A.667.667,0,0,1,15.331,5V9.749Zm-2.666,2.582V10L16,13l-3.333,3V13.664h-2V12.331Z\" transform=\"translate(-0.665 -0.997)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol